import { Typography } from '@euler/app/components/typography';
import { InspectionTaskJobStatus } from '@euler/model/enum';
import { memo } from 'react';
import { View } from 'react-native';
import { useBoardUnit } from '../../functions/useBoardUnit';
import { workshopBoardColors as colors } from '../../workshopBoardColors';

/** 施工中 in the active color with its dot; 待施工 dimmed. */
export const JobStatusCell = memo(
  ({ status, flex }: { status: InspectionTaskJobStatus; flex: number }) => {
    const u = useBoardUnit();
    const working = status === InspectionTaskJobStatus.InProgress;
    return (
      <View
        style={{ flex, flexDirection: 'row', alignItems: 'center', gap: u(10) }}
      >
        <View
          style={{
            width: u(14),
            height: u(14),
            borderRadius: u(7),
            backgroundColor: working ? colors.active : colors.faint,
          }}
        />
        <Typography.Text
          size={u(26)}
          color={working ? colors.active : colors.muted}
          numberOfLines={1}
        >
          {working ? '施工中' : '待施工'}
        </Typography.Text>
      </View>
    );
  },
);
